import {isValidPhoneNumber} from "react-phone-number-input";
import {validatePhoneNumberLength} from "libphonenumber-js";

/**
 * Returns a Ukrainian error string when phone is invalid, or "" when valid/empty.
 * Uses libphonenumber metadata for country-specific length validation.
 */
export function validatePhone(value) {
	if (!value) return "";
	const lengthStatus = validatePhoneNumberLength(value);
	if (lengthStatus === "TOO_SHORT" || lengthStatus === "INVALID_LENGTH") {
		return "Номер має бути повним";
	}
	if (lengthStatus === "TOO_LONG") return "Завелика кількість цифр";
	if (lengthStatus === "NOT_A_NUMBER") return "Невірний формат номера";
	if (lengthStatus === "INVALID_COUNTRY") return "Невідомий код країни";
	if (!isValidPhoneNumber(value)) return "Невірний номер телефону";
	return "";
}
